import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { StageComponent } from '../../components/stage/stage.component';
import { TariffCarouselComponent } from '../../components/tariff-carousel/tariff-carousel.component';

/**
 * Private customers landing page component.
 *
 * @remarks Displays the main landing page for private customers with stage section
 * and tariff carousel. This component serves as the primary entry point for
 * private customer services and product offerings.
 */
@Component({
  selector: 'app-private-customers',
  templateUrl: './private-customers.component.html',
  styleUrls: ['./private-customers.component.scss'],
  standalone: true,
  imports: [CommonModule, RouterModule, StageComponent, TariffCarouselComponent],
})
export class PrivateCustomersComponent {}
